import { createTranslations } from '@npco/utils-translations'

export const logoutInactivityTimeoutTranslations = createTranslations({
  loadingMessage: 'Logging out due to inactivity. Redirecting to login.',
})
